import { ScoutLoginPage } from '@/features/login/scout-login-page';
import { createFileRoute } from '@tanstack/react-router';

import z from 'zod';

const searchSchema = z
  .object({
    state: z.string(),
    redirect_uri: z.string(),
  })
  .catchall(z.unknown());

export const Route = createFileRoute('/login/scout')({
  validateSearch: searchSchema,
  component: ScoutLoginPage,
});
